module.exports = __webpack_public_path__ + "static/media/profileYellow.0172cb53.svg";